<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { SUPPORTED, setLocale, type Locale } from '@/i18n'

const { t, locale } = useI18n()
const LABELS: Record<Locale, string> = { da: '🇩🇰 DA', en: '🇬🇧 EN', es: '🇪🇸 ES' }

function onChange(e: Event) {
  setLocale((e.target as HTMLSelectElement).value as Locale)
}
</script>

<template>
  <select class="lang" :value="locale" :aria-label="t('nav.language')" @change="onChange">
    <option v-for="l in SUPPORTED" :key="l" :value="l">{{ LABELS[l] }}</option>
  </select>
</template>

<style scoped>
.lang {
  appearance: none;
  padding: 0.35rem 0.5rem;
  border-radius: 8px;
  border: 1px solid var(--surface-2);
  background: transparent;
  color: var(--text);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
.lang:focus-visible { outline: 2px solid var(--accent); }
</style>
